import React, { ReactElement } from 'react';
import Button from 'atomic/utilization/button';

import './adult-container.scss';

const AdultContainer: React.FC<{ agree: () => void; disagree: () => void; }> = ({ agree, disagree }): ReactElement => (
    <div className="adult-container">
        <div className="adult">
            <div className="container">
                <div className="adult-icon">
                    <i className="icon-adults2"/>
                </div>
                <div className="adult-main">
                    <div className="adult-main__text">
                        <span>
                            Treści znajdujące się na tej stronie są przeznaczone dla osób pełnoletnich.
                        </span>
                    </div>
                </div>
                <div className="adult-footer">
                    <div className="adult-footer__text">
                        <span>
                            Czy masz ukończone 18 lat?
                        </span>
                    </div>
                    <div className="adult-footer__button">
                        <Button color="blue" size="lg" uppercase={true}
                            onClick={agree}
                        >
                            Tak
                        </Button>
                        <Button color="blue" size="lg" uppercase={true}
                            onClick={disagree}
                        >
                            Nie
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default AdultContainer;
